import gql from 'graphql-tag'

import configureApolloClient from 'network/index'

import {
  savePageChanges
} from 'actions/editor'

const apolloClient = configureApolloClient()

export const CREATE_PROJECT_STATE = 'CREATE_PROJECT_STATE'
export const DESTROY_PROJECT_STATE = 'DESTROY_PROJECT_STATE'

export const SET_PROJECT_DEVICE = 'SET_PROJECT_DEVICE'

export const PUBLISH_PROJECT_REQUEST = 'PUBLISH_PROJECT_REQUEST'
export const PUBLISH_PROJECT_SUCCESS = 'PUBLISH_PROJECT_SUCCESS'
export const PUBLISH_PROJECT_COMPLETE = 'PUBLISH_PROJECT_COMPLETE'

export const createProjectState = ({ project, components, integrations }) => ({
  type: CREATE_PROJECT_STATE,
  project,
  components,
  integrations
})

export const destroyProjectState = () => ({
  type: DESTROY_PROJECT_STATE
})

export const setProjectDevice = device => ({
  type: SET_PROJECT_DEVICE,
  device
})

export const publishProject = mode => async (dispatch, getState) => {
  try {
    const { project } = getState().project

    dispatch({
      type: PUBLISH_PROJECT_REQUEST
    })

    switch (mode) {
      case 'editor':
        await dispatch(savePageChanges({ silent: true }))
        break

      default:
    }

    await apolloClient.mutate({
      variables: {
        projectId: project._id
      },
      mutation: gql`
        mutation publishProject($projectId: ID!) {
          publishProject(projectId: $projectId) {
            _id
          }
        }
      `
    })

    dispatch({
      type: PUBLISH_PROJECT_SUCCESS
    })

    setTimeout(() => {
      dispatch({
        type: PUBLISH_PROJECT_COMPLETE
      })
    }, 800)
  } catch (error) {
    // todo: invoke notification
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/project.js